"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processNameList = void 0;
const error_1 = require("../../parser/cst/error");
const controls_1 = require("../../node/el/controls");
const _nameListHead_1 = __importDefault(require("../sentenceChildrenParser/rules/$nameListHead"));
const env_1 = require("../sentenceChildrenParser/env");
const sentenceEnv_1 = require("../../node/container/sentenceEnv");
const std = __importStar(require("../../law/std"));
const getScope_1 = __importDefault(require("../pointerEnvs/getScope"));
const processNameList = (headSentenceEnv, sentenceEnvsStruct, pointerEnvsStruct) => {
    const errors = [];
    const declarations = [];
    const result = _nameListHead_1.default.match(0, headSentenceEnv.el.children, (0, env_1.initialEnv)({ target: "" }));
    if (result.ok) {
        const { pointerRanges } = result.value.value;
        if (pointerRanges)
            (0, getScope_1.default)({ pointerRangesToBeModified: pointerRanges, pointerEnvsStruct });
        const scope = (0, sentenceEnv_1.toSentenceTextRanges)(pointerRanges.targetContainerIDRanges, sentenceEnvsStruct);
        if (scope.length === 0) {
            errors.push(new error_1.ErrorMessage("No scope found", [
                pointerRanges?.range?.[0] ?? 0,
                pointerRanges?.range?.[1] ?? 0,
            ]));
        }
        for (const nameContainer of headSentenceEnv.container.children) {
            const paragraphItemSentence = nameContainer.el.children.find(std.isParagraphItemSentence);
            if (!paragraphItemSentence || paragraphItemSentence.children.length === 0)
                continue;
            if (paragraphItemSentence.children.every(std.isSentence)) {
                const sentence = paragraphItemSentence.children[0];
                if (sentence.children.length <= 1)
                    continue;
                const sentenceEnv = sentenceEnvsStruct.sentenceEnvByEL.get(sentence);
                if (!sentenceEnv)
                    continue;
                const nameChild = sentence.children[0];
                if (!(nameChild instanceof controls_1.__Parentheses && nameChild.attr.type === "square"))
                    continue;
                const name = nameChild.content.text();
                const afterNameChild = sentence.children[1];
                if (!(afterNameChild instanceof controls_1.__Text))
                    continue;
                const afterNameMatch = /^とは、/.exec(afterNameChild.text());
                if (!afterNameMatch)
                    continue;
                const lastChild = sentence.children[sentence.children.length - 1];
                if (!(lastChild instanceof controls_1.__Text))
                    continue;
                const lastMatch = /をいう。$/.exec(lastChild.text());
                if (!lastMatch)
                    continue;
                const nameTextRange = sentenceEnv.textRageOfEL(nameChild.content);
                if (!nameTextRange) {
                    errors.push(new error_1.ErrorMessage("nameTextRange is null", [
                        pointerRanges?.range?.[0] ?? 0,
                        pointerRanges?.range?.[1] ?? 0,
                    ]));
                    continue;
                }
                const nameSentenceTextRange = {
                    start: {
                        sentenceIndex: sentenceEnv.index,
                        textOffset: nameTextRange[0],
                    },
                    end: {
                        sentenceIndex: sentenceEnv.index,
                        textOffset: nameTextRange[1],
                    },
                };
                const declarationID = `decl-sentence_${sentenceEnv.index}-text_${nameSentenceTextRange.start.textOffset}_${nameSentenceTextRange.end.textOffset}`;
                const valueTextRange = [
                    nameChild.text().length + afterNameMatch[0].length,
                    sentence.text().length - lastMatch[0].length,
                ];
                const declaration = new controls_1.____Declaration({
                    declarationID,
                    type: "Keyword",
                    name,
                    value: {
                        isCandidate: false,
                        text: sentence.text().slice(...valueTextRange),
                        sentenceTextRange: ((start, end) => ({ start: { sentenceIndex: sentenceEnv.index, textOffset: start }, end: { sentenceIndex: sentenceEnv.index, textOffset: end } }))(...valueTextRange),
                    },
                    scope: scope,
                    nameSentenceTextRange,
                    range: nameChild.content.range,
                    children: [name],
                });
                declarations.push(declaration);
                nameChild.content.children.splice(0, nameChild.content.children.length, declaration);
            }
            else if (paragraphItemSentence.children.every(std.isColumn)) {
                if (paragraphItemSentence.children.length !== 2)
                    continue;
                const [nameColumn, defColumn] = paragraphItemSentence.children;
                if (nameColumn.children.length !== 1)
                    continue;
                const nameSentence = nameColumn.children[0];
                if (!std.isSentence(nameSentence))
                    continue;
                const nameSentenceEnv = sentenceEnvsStruct.sentenceEnvByEL.get(nameSentence);
                if (!nameSentenceEnv)
                    continue;
                const name = nameSentenceEnv.text;
                const nameSentenceTextRange = {
                    start: {
                        sentenceIndex: nameSentenceEnv.index,
                        textOffset: 0,
                    },
                    end: {
                        sentenceIndex: nameSentenceEnv.index,
                        textOffset: name.length,
                    },
                };
                const declarationID = `decl-sentence_${nameSentenceEnv.index}-text_${nameSentenceTextRange.start.textOffset}_${nameSentenceTextRange.end.textOffset}`;
                const valueSentenceEnvs = defColumn.children.map(c => sentenceEnvsStruct.sentenceEnvByEL.get(c)).filter(s => s);
                const lastMatch = /をいう。$/.exec(defColumn.text());
                const declaration = new controls_1.____Declaration({
                    declarationID,
                    type: "Keyword",
                    name,
                    value: {
                        isCandidate: false,
                        text: valueSentenceEnvs.map(s => s.text).join().slice(0, lastMatch ? -lastMatch[0].length : undefined),
                        sentenceTextRange: {
                            start: {
                                sentenceIndex: valueSentenceEnvs[0].index,
                                textOffset: 0,
                            },
                            end: {
                                sentenceIndex: valueSentenceEnvs[valueSentenceEnvs.length - 1].index,
                                textOffset: valueSentenceEnvs[valueSentenceEnvs.length - 1].text.length - (lastMatch ? lastMatch[0].length : 0),
                            },
                        },
                    },
                    scope: scope,
                    nameSentenceTextRange,
                    range: nameSentence.range,
                    children: [...nameSentence.children],
                });
                declarations.push(declaration);
                nameSentence.children.splice(0, nameSentence.children.length, declaration);
            }
        }
    }
    return {
        value: declarations,
        errors,
    };
};
exports.processNameList = processNameList;
//# sourceMappingURL=processNameList.js.map